import React, { useState } from 'react';
import styles from './AddFilePopup.module.css';
import { useDispatch } from 'react-redux';
import { addFileRedux } from '../../store/slices/filesSlice';
import { generateRandomString, getReadableFileSize } from '../../helper';
import { addDocBd, uploadFile } from '../../firebase';
import LoaderElementAbsolute from '../LoaderElementAbsolute/LoaderElementAbsolute';

const AddFilePopup = ({ onClose, fileType = 'video' }) => {
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [preview, setPreview] = useState('');
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [file, setFile] = useState(null);
  const [sizeObject, setSizeObject] = useState(null);

  // Зберігає данні на сервер
  const uploadHandler = async () => {
    setLoader(true);
    if (!title) {
      alert('Додайте Заголовок');
      setLoader(false);
      return;
    }
    if (!description) {
      alert('Додайте Опис');
      setLoader(false);
      return;
    }
    if (!file) {
      alert('Додайте Файл');
      setLoader(false);
      return;
    }

    // Зберегая файл на сервер
    const downloadURL = await uploadFile(file);

    if (downloadURL) {
      const fileObject = {
        id: generateRandomString(),

        fileType: fileType,
        size: sizeObject,
        title: title,
        description: description,
        url: downloadURL,
        createdAt: Date.now(), // додає дату в мілісекундах
      };

      // Зберегая обєкт на сервер
      const isAddDoc = await addDocBd('files', fileObject.id, fileObject);

      if (isAddDoc) {
        // Зберегая обєкт в redax
        dispatch(addFileRedux({ ...fileObject, newFile: true }));
        onClose();
      } else {
        alert('Не вдалось жавантажити обєкт в базу даних!!!');
      }
    } else {
      alert('Не вдалось жавантажити файл!!!');
    }

    setLoader(false);
  };

  const handleSelect = (e) => {
    const selected = e.target.files[0];
    setFile(selected);

    if (selected) {
      setSizeObject(getReadableFileSize(selected.size));
      const localPreview = URL.createObjectURL(selected);
      setPreview(localPreview);
    }
  };

  return (
    <div className={styles.overlay} onClick={onClose}>
      <div className={styles.popup} onClick={(e) => e.stopPropagation()}>
        <h2 className={styles.header}>Додати файл</h2>

        <div className={styles.field}>
          <label>Заголовок</label>
          <input
            type="text"
            className={styles.input}
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Введіть назву..."
          />
        </div>

        <div className={styles.field}>
          <label>Опис</label>
          <textarea
            className={styles.textarea}
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Короткий опис..."></textarea>
        </div>

        <div className={styles.field}>
          <label>Виберіть файл</label>
          <input
            type="file"
            accept={fileType + '/*'}
            className={styles.fileInput}
            onChange={handleSelect}
          />
        </div>

        {preview && (
          <>
            <h3>
              Попередній перегляд:{' '}
              {sizeObject ? (
                <span>
                  {sizeObject.value} {sizeObject.label}
                </span>
              ) : (
                ''
              )}
            </h3>
            <div className={styles.preview}>
              {file.type.startsWith('image/') && (
                <img src={preview} alt="preview" style={{ maxWidth: '100%', maxHeight: '150px' }} />
              )}

              {file.type.startsWith('video/') && (
                <video width="100%" height="150" controls>
                  <source src={preview} type={file.type} />
                </video>
              )}
            </div>
          </>
        )}

        <div className={styles.buttons}>
          <button className={styles.uploadBtn} onClick={() => uploadHandler()}>
            Завантажити
          </button>
          <button className={styles.cancelBtn} onClick={onClose}>
            Скасувати
          </button>
        </div>

        {/* ------- loader -------- */}
        {loader ? <LoaderElementAbsolute /> : ''}

        {/* -------- /loader ------- */}
      </div>
    </div>
  );
};

export default AddFilePopup;
